<template>
  <div id="Header">
    <div id="HeaderInline">
      <h1>RoosterKracht</h1>
      <img
        src="../assets/presented-by-logo.png"
        width="75"
        height="100"
        id="HeaderImage"
      />
    </div>
    <hr />
  </div>
  <div id="Header" style="position: static; opacity: 0">
    <div id="HeaderInline">
      <h1>RoosterKracht</h1>
      <img
        src="../assets/presented-by-logo.png"
        width="75"
        height="100"
        id="HeaderImage"
      />
    </div>
    <hr />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeaderBar",
  props: {},
});
</script>

<style>
#Header {
  font-family: "Manrope", sans-serif;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
  width: 95vw;
  transform: translateX(2.5vw) translate(-5vw, calc(-5vw - 10px));
  position: fixed;
  z-index: 9999;
  background-color: var(--background);
  padding: 5vw;
  padding-bottom: 0;
}

#Header hr {
  width: 90vw;
  border-color: var(--text);
  transform: translateY(-15px);
}

#HeaderInline {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
}

#HeaderImage {
  transform: translateY(-10px);
}
</style>
